
export default {
  name: "BlackFridaySale",
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
